import { render, staticRenderFns } from "./dialogAddApprover.vue?vue&type=template&id=398f5620&scoped=true"
import script from "./dialogAddApprover.vue?vue&type=script&lang=js"
export * from "./dialogAddApprover.vue?vue&type=script&lang=js"
import style0 from "./dialogAddApprover.vue?vue&type=style&index=0&id=398f5620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f5620",
  null
  
)

export default component.exports